package io.horion.cv.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.components.Footer
import io.horion.cv.components.Topbar
import io.horion.cv.components.widgets.PricingCard
import io.horion.cv.styles.PriceSectionContainerStyle
import io.horion.cv.styles.PriceTitleStyle
import io.horion.cv.utils.Colors

@OptIn(DelicateApi::class)
@Page("/price")
@Composable
fun Price() {
    val breakpoint = rememberBreakpoint()
    val isMobile = breakpoint <= Breakpoint.MD
    val isTablet = breakpoint == Breakpoint.LG
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    val pageBg    = if (isDark) Colors.DarkBG   else Colors.White
    val titleColor = if (isDark) Colors.White   else Colors.DarkBlue

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .backgroundColor(pageBg)
            .styleModifier { property("transition", "background-color 300ms ease") },
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Topbar()

        Column(
            modifier = PriceSectionContainerStyle.toModifier()
                .fillMaxWidth(),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SpanText(
                text = "Tarification",
                modifier = PriceTitleStyle.toModifier()
                    .fontWeight(FontWeight.Bold)
                    .color(titleColor)
            )
            PricingCard(
                price = "XAF 500",
                priceSubtext = "/ document",
                billingInfo = "Facturé à la demande",
                features = listOf(
                    "Paiement unique, sans abonnement.",
                    "Orange Money et MTN Mobile Money acceptés.",
                    "Téléchargement immédiat après paiement."
                )
            )
        }

        Footer()
    }
}
